import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./utils/i18n.js";
import { LicenseInfo } from "@mui/x-license-pro";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { UserProvider } from "./contexts/UserContext";

// 초기 로드 코드 분할(#92) — 라우트 단위 lazy.
// 목록(/) 진입 시 MatrixBoard 청크(reactflow/quill 등)를 받지 않는다.
const Files = lazy(() => import("./components/pages/matrixBoard/Files"));
const MatrixBoard = lazy(() => import("./components/pages/matrixBoard/MatrixBoard"));

LicenseInfo.setLicenseKey("bdd2fba0c1674c6e17d94906bf2f3ab8Tz0xMTk0OTgsRT0xNzkwMzgwNzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y");

function App() {
  return (
    <UserProvider>
      <Router basename={process.env.PUBLIC_URL || ''}>
        <Suspense fallback={<div style={{ width: '100vw', height: '100vh', background: '#fff' }} />}>
          <Routes>
            {/* 매트릭스 보드 - Microsoft SSO 인증 필요 */}
            <Route path="/" element={<ProtectedRoute><Files /></ProtectedRoute>} />
            <Route path="/:fileId" element={<ProtectedRoute><MatrixBoard /></ProtectedRoute>} />
          </Routes>
        </Suspense>
      </Router>
    </UserProvider>
  );
}

export default App;
